export default "/icon_allot.cf11873a-bdd894.png";